import { useAuth0 } from '@auth0/auth0-react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { ProfileHeaderText, ProfileHeaderToolbar } from './styledComponents';

export const ProfileHeader = () => {
  const { user } = useAuth0();

  return (
    <AppBar position="absolute">
      <ProfileHeaderToolbar>
        <Box sx={{ pb: 1, px: 2 }}>
          <ProfileHeaderText data-sentry-mask variant="h6">
            {user?.name}
          </ProfileHeaderText>
          <ProfileHeaderText data-sentry-mask variant="body2">
            {user?.email}
          </ProfileHeaderText>
        </Box>
      </ProfileHeaderToolbar>
    </AppBar>
  );
};
